// Extras de la renovación (add-on "solo agregar") y el requisito de Contabilidad (H13):
// «Contabilidad completa» necesita el Kardex, sea porque el plan lo trae o porque se suma
// «Kardex + composición» como extra. Es la misma regla que aplican el sitio, el alta y
// savePaymentRecord en el backend.
export const ACCOUNTING_NEEDS_KARDEX = 'La contabilidad completa requiere Kardex + composición.';

function extraModules(plan, ids) {
    const extras = (plan && plan.extras) || [];
    return extras.filter(e => ids.includes(e.id)).flatMap(e => e.modules || []);
}

function planModules(plan) {
    return ((plan && plan.modules) || []).map(m => (typeof m === 'string' ? m : m.id));
}

export function isAccountingExtra(extra) {
    return (extra.modules || []).includes('contabilidad');
}

export function accountingAvailable(plan, selectedIds) {
    return planModules(plan).includes('kardex') || extraModules(plan, selectedIds || []).includes('kardex');
}

export function extraDisabled(extra, plan, selectedIds) {
    return isAccountingExtra(extra) && !accountingAvailable(plan, selectedIds);
}

// Selección válida tras un cambio: sin Kardex, Contabilidad se desmarca.
export function normalizeExtras(plan, selectedIds) {
    const ids = [...(selectedIds || [])];
    if (accountingAvailable(plan, ids)) return ids;
    const accounting = ((plan && plan.extras) || []).filter(isAccountingExtra).map(e => e.id);
    return ids.filter(id => !accounting.includes(id));
}
